import Hero from "../../components/Hero/Hero";
import FeatureBar from "../../components/FeatureBar/FeatureBar";
import MissionVision from "../../components/MissionVision/MissionVision";
import CareClicks from "../../components/CareClicks/CareClicks";
import Stats from "../../components/Stats/Stats";
import Products from "../../components/Products/Products";

function Home({ onNavigate }) {
  return (
    <main>
      <Hero />
      <FeatureBar />
      <MissionVision />
      <CareClicks />
      <Stats />
      <Products onNavigate={onNavigate} />
    </main>
  );
}

export default Home;